import currentPartner, { isPartnerBasePath } from '../constants/partners';
import localStorage from './localStorage';

const SESSION_PARTNER_BASE_PATH = 'SESSION_PARTNER_BASE_PATH';

// An empty base path means the session belongs to the app without a partner.
export const saveSessionPartner = () => {
  localStorage.set(SESSION_PARTNER_BASE_PATH, currentPartner?.basePath ?? '');
};

export const clearSessionPartner = () => {
  localStorage.remove(SESSION_PARTNER_BASE_PATH);
};

// A partner removed since the login would otherwise redirect forever, as its
// path is no longer recognised as a partner.
const isAppBasePath = (basePath: unknown): basePath is string =>
  basePath === '' ||
  (typeof basePath === 'string' && isPartnerBasePath(basePath));

/**
 * Sends a logged-in user who opened a link for another app (another partner,
 * or with or without a partner) back to the app their session belongs to,
 * since the partner is only known from the URL.
 *
 * @returns true if a redirect was started
 */
export const redirectToSessionPartner = (isUserLoggedIn?: boolean): boolean => {
  const basePath = localStorage.get<string>(SESSION_PARTNER_BASE_PATH);
  const currentBasePath = currentPartner?.basePath ?? '';

  if (!isAppBasePath(basePath) || !isUserLoggedIn) {
    clearSessionPartner();
    return false;
  }

  if (basePath === currentBasePath) {
    return false;
  }

  const { pathname, search, hash } = window.location;
  const appPath = pathname.slice(currentBasePath.length);
  const path = `${basePath}${appPath === '/' ? '' : appPath}` || '/';
  window.location.replace(`${path}${search}${hash}`);
  return true;
};
